<div>
    <form nz-form #projectMasterPage="ngForm">
        <!-- <div nz-row nzGutter="5" *ngIf="ShowLinkOrNot">
            <div nz-col nzSpan="24">
                <a style="float: right;" (click)="openWorkLogsDrawer()">Work Logs</a>
            </div>
        </div> -->

        <div nz-row class="my-box" nzGutter="5">
            <div nz-col nzSpan="24">
                <nz-form-item>
                    <div nz-row>
                        <div nz-col nzSpan="3">
                            <nz-form-label nzRequired nzNoColon>Client</nz-form-label>
                        </div>

                        <div nz-col nzSpan="3">
                            <span (click)="openClientDrawer()" style="cursor: pointer;">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                    width="40" height="40" viewBox="0 0 40 40"
                                    style="margin-top: -5px; margin-left: -20px;">
                                    <defs>
                                        <filter id="Ellipse_1" x="0" y="0" width="40" height="40"
                                            filterUnits="userSpaceOnUse">
                                            <feOffset input="SourceAlpha" />
                                            <feGaussianBlur stdDeviation="3" result="blur" />
                                            <feFlood flood-color="#4892ff" flood-opacity="0.361" />
                                            <feComposite operator="in" in2="blur" />
                                            <feComposite in="SourceGraphic" />
                                        </filter>
                                    </defs>
                                    <g id="Attachment_Icon" data-name="Attachment Icon"
                                        transform="translate(-523 -350)">
                                        <g transform="matrix(1, 0, 0, 1, 523, 350)" filter="url(#Ellipse_1)">
                                            <circle id="Ellipse_1-2" data-name="Ellipse 1" cx="11" cy="11" r="11"
                                                transform="translate(9 9)" fill="#e8f1ff" />
                                        </g>
                                        <g id="Group_2" data-name="Group 2" transform="translate(4 3.9)">
                                            <path id="Path_2" data-name="Path 2" d="M543,361.1v10"
                                                transform="translate(-4)" fill="none" stroke="#0061f3"
                                                stroke-linecap="round" stroke-width="1" />
                                            <path id="Path_3" data-name="Path 3" d="M0,0V10"
                                                transform="translate(544 366.1) rotate(90)" fill="none" stroke="#0061f3"
                                                stroke-linecap="round" stroke-width="1" />
                                        </g>
                                    </g>
                                </svg>
                            </span>
                        </div>
                    </div>

                    <nz-form-control>
                        <nz-select name="clientName" nzShowSearch nzAllowClear [nzLoading]="isClientLoading"
                            nzPlaceHolder="Select a Client" [(ngModel)]="data.PROJECT_CLIENT_ID">
                            <nz-option *ngFor="let client of clientList" [nzValue]="client.ID" [nzLabel]="client.NAME">
                            </nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>

        <div nz-row class="my-box" nzGutter="6">
            <div nz-col nzSpan="16">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Project Name</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Project Name is Required">
                        <input nz-input autocomplete="off" name="projectName" type="text"
                            placeHolder="Enter a Project Name" pattern="([A-Za-z0-9\s]){1,}" [(ngModel)]="data.NAME"
                            required />
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Status</nz-form-label>

                    <nz-form-control>
                        <nz-select name="status" nzShowSearch nzAllowClear nzPlaceHolder="Status"
                            [(ngModel)]="data.STATUS">
                            <nz-option nzLabel="Active" nzValue="A"></nz-option>
                            <nz-option nzLabel="On Hold" nzValue="OH"></nz-option>
                            <nz-option nzLabel="Completed" nzValue="C"></nz-option>
                            <nz-option nzLabel="Cancel" nzValue="CN"></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-label nzNoColon>Description</nz-form-label>

                    <nz-form-control>
                        <textarea nz-input [nzAutosize]="{ minRows: 3, maxRows: 6 }" name="projectDescription"
                            placeHolder="Enter a Project Description" [(ngModel)]="data.DESCRIPTION"
                            maxlength="500"></textarea>
                    </nz-form-control>

                    <span *ngIf="data.DESCRIPTION" style="font-size: 10px; color: red;">{{data.DESCRIPTION.length}}/
                        500</span>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="6">
                <nz-form-item>
                    <nz-form-label nzNoColon>Start Date</nz-form-label>

                    <nz-form-control>
                        <nz-date-picker style="width: 100%;" nzFormat="dd/MM/yyyy" name="startDate"
                            (nzOnOpenChange)="projectStartDateHandle($event)" [(ngModel)]="data.START_DATE">
                        </nz-date-picker>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="6">
                <nz-form-item>
                    <nz-form-label nzNoColon>End Date</nz-form-label>

                    <nz-form-control>
                        <nz-date-picker #endDatePicker style="width: 100%;" nzFormat="dd/MM/yyyy" name="endDate"
                            [nzDisabledDate]="disabledProjectEndDate" [(ngModel)]="data.END_DATE"></nz-date-picker>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="6">
                <nz-form-item>
                    <nz-form-label nzNoColon>Estimated Mandays</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Estimated Mandays is Required">
                        <input nz-input name="estimatedMandays" type="number" min="1"
                            oninput="this.value = Math.abs(this.value)" placeHolder="Enter Mandays"
                            [(ngModel)]="data.ESTIMATED_MANDAYS" />
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="6">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>
                        Sequence No.
                    </nz-form-label>
                    <nz-form-control nzHasFeedback nzErrorTip=" Please Enter Correct Sequence Number ">
                        <input nz-input placeholder="Sequence No." name="unitseq" style="width: 100%" minlength="1"
                            maxlength="3" [(ngModel)]="data.SEQ_NO" (keypress)="omit($event)" maxlength="5" required />
                    </nz-form-control>
                </nz-form-item>
            </div>

            <!-- <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Estimated Hours</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Estimated Hours is Required">
                        <input nz-input name="estimatedHours" type="number" min="0" oninput="this.value = Math.abs(this.value)" placeHolder="Enter Hours" [(ngModel)]="data.ESTIMATED_HOURS" required/>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Estimated Minutes</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Estimated Minutes is Required">
                        <input nz-input name="estimatedMinutes" type="number" min="0" oninput="this.value = Math.abs(this.value)" onkeyup="if(this.value> 60){this.value= 60}" placeHolder="Enter Minutes" [(ngModel)]="data.ESTIMATED_MINUTES" required/>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Estimated Seconds</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Estimated Seconds is Required">
                        <input nz-input name="estimatedSeconds" type="number" min="0" oninput="this.value = Math.abs(this.value)" onkeyup="if(this.value> 60){this.value= 60}" placeHolder="Enter Seconds" [(ngModel)]="data.ESTIMATED_SECONDS" required/>
                    </nz-form-control>
                </nz-form-item>
            </div> -->
        </div>

        <div nz-row class="my-box" nzGutter="8">
            <!-- <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Icon &nbsp;
                        <a href="https://ng.ant.design/components/icon/en" target="blank"><i nz-icon nzType="eye"
                                nzTheme="outline"></i></a>
                    </nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Icon Name is Required">
                        <input nz-input name="icon" type="text" placeHolder="Enter Icon Name" [(ngModel)]="data.ICON"
                            required />
                    </nz-form-control>
                </nz-form-item>
            </div> -->

            <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Abbrevation&nbsp;
                        <i style="color: blue;" nz-icon nzType="eye" nzTheme="outline" (click)="makeAbbrevation()"></i>
                    </nz-form-label>

                    <nz-form-control>
                        <input nz-input autocomplete="off" name="abbrevation" type="text"
                            placeHolder="Project Abbrevation" minlength="1" maxlength="5"
                            [(ngModel)]="data.ABBREVATION" />
                    </nz-form-control>

                    <span *ngIf="data.ABBREVATION" style="font-size: 10px; color: red;">{{data.ABBREVATION.length}}/
                        5</span>
                </nz-form-item>
            </div>



            <div nz-col nzSpan="4">
                <nz-form-item>
                    <nz-form-label nzNoColon>Active</nz-form-label>

                    <nz-form-control>
                        <nz-switch name="isActive" [(ngModel)]="data.IS_ACTIVE"></nz-switch>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzNoColon>Include In Report</nz-form-label>

                    <nz-form-control>
                        <nz-switch name="IS_GENERATE_REPORT" [(ngModel)]="data.IS_GENERATE_REPORT"></nz-switch>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
        <div nz-row class="my-box" nzGutter="8">
            <div nz-col nzSpan="3">
                <nz-form-item>
                    <nz-form-label nzNoColon>Billable</nz-form-label>

                    <nz-form-control>
                        <nz-switch name="isBillable" [(ngModel)]="data.IS_BILLABLE" (ngModelChange)="ischanged('B')"></nz-switch>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzSpan="4">
                <nz-form-item>
                    <nz-form-label nzNoColon>Non-Billable</nz-form-label>

                    <nz-form-control>
                        <nz-switch name="isnonBillable" [(ngModel)]="data.NON_BILABLE"  (ngModelChange)="ischanged('NB')"></nz-switch>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzSpan="7">
                <nz-form-item>
                    <nz-form-label nzNoColon>Is Reserch Development?</nz-form-label>

                    <nz-form-control>
                        <nz-switch name="RESERCH_DEVLOPMENT" [(ngModel)]="data.RESERCH_DEVLOPMENT"  (ngModelChange)="ischanged('RD')"></nz-switch>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzSpan="5">
                <nz-form-item>
                    <nz-form-label nzNoColon>Is Training?</nz-form-label>

                    <nz-form-control>
                        <nz-switch name="TRAINING" [(ngModel)]="data.TRAINING"  (ngModelChange)="ischanged('T')"></nz-switch>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzSpan="5">
                <nz-form-item>
                    <nz-form-label nzNoColon>Is Other?</nz-form-label>

                    <nz-form-control>
                        <nz-switch name="OTHER" [(ngModel)]="data.OTHER"  (ngModelChange)="ischanged('O')"></nz-switch>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
    </form>
</div>

<div class="footer">
    <button type="button" nz-button class="ant-btn" style="margin-right: 8px;"
        (click)="close(projectMasterPage)"><span>Cancel</span></button>

    <button type="button" class="ant-btn ant-btn-primary" *ngIf="!data.ID" nz-button [nzLoading]="isSpinning"
        nz-dropdown [nzDropdownMenu]="menu" (click)="save(false)"><span>Save & Close</span></button>
    <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu>
            <li nz-menu-item class="menuc" style="border-radius: 4px;background-color: #40a9ff;">
                <a (click)="save(true)">Save & New</a>
            </li>
        </ul>
    </nz-dropdown-menu>
    <button type="button" class="ant-btn ant-btn-primary" nz-button [nzLoading]="isSpinning" *ngIf="data.ID"
        (click)="save(false)"><span>Update & close</span></button>

    <!-- <button type="button" nz-button class="ant-btn" style="margin-right: 8px;"
        (click)="resetDrawer(projectMasterPage)"><span>Reset</span></button> -->
</div>
<div *ngIf="drawerVisible">
    <nz-drawer [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom': '53px' }"
        [nzClosable]="true" [nzMask]="true" [nzMaskClosable]="false" [nzWidth]="600" [nzVisible]="drawerVisible"
        [nzTitle]="drawerTitle" (nzOnClose)="clientDrawerClose()" (nzKeyboard)="true">
        <app-client-drawer [drawerClose]="callBackClientkDrawerClose" [data]="clientDrawerData"></app-client-drawer>
    </nz-drawer>
</div>